import { lazy } from 'react';
// ----------------------------------------------------------------------

const StudentRealtionsPage = lazy(() => import('../pages/StudentRealtions.page'));
const AddStudentPage = lazy(() => import('../pages/AddStudent.page'));
const ViewStudentPage = lazy(() => import('../pages/ViewStudent.page'));
const EditStudentPage = lazy(() => import('../pages/EditStudent.page'));
const ComplaintsAndMsg = lazy(() => import('../pages/complaints-and-messages/ComplaintsAndMsg.pag'));
const AddComplaintPage = lazy(() => import('../pages/AddComplaint.page'));
const StudentCommunicationPage = lazy(() => import('../pages/StudentCommunication.page'));
const ListMessage = lazy(() => import('../pages/ListMessage.page'));
const AddMessagePage = lazy(() => import('../pages/AddMessage.page'));
const MarketingPage = lazy(() => import('../pages/Marketing.page'));
const ArchivePage = lazy(() => import('../pages/Archive.page'));

// ----------------------------------------------------------------------

const StudentRealtionsRoutes = [
    {
        path: 'student-relations',
        children: [
            { element: <StudentRealtionsPage />, layout: 'default', isAuthReq: true, index: true },
            {
                path: 'add-student',
                element: <AddStudentPage />,
                layout: 'default',
                isAuthReq: true,
            },
            {
                path: 'view-student/:id',
                element: <ViewStudentPage />,
                layout: 'default',
                isAuthReq: true,
            },
            {
                path: 'edit-student/:id',
                element: <EditStudentPage />,
                layout: 'default',
                isAuthReq: true,
            },
            {
                path: 'complaints-and-messages',
                children: [
                    {
                        element: <ComplaintsAndMsg />,
                        layout: 'default',
                        isAuthReq: true,
                        index: true,
                    },
                    {
                        path: 'add',
                        element: <AddComplaintPage />,
                        layout: 'default',
                        isAuthReq: true,
                    },
                ],
            },
            {
                path: 'student-communication',
                children: [
                    {
                        element: <StudentCommunicationPage />,
                        layout: 'default',
                        isAuthReq: true,
                        index: true,
                    },
                    {
                        path: 'add-message',
                        children: [
                            { element: <AddMessagePage />, layout: 'default', isAuthReq: true, index: true },
                            {
                                path: ':id',
                                element: <AddMessagePage />,
                                layout: 'default',
                                isAuthReq: true,
                            },
                        ],
                    },
                    {
                        path: 'list-message',
                        children: [
                            { element: <ListMessage />, layout: 'default', isAuthReq: true, index: true },
                            {
                                path: ':id',
                                element: <ListMessage />,
                                layout: 'default',
                                isAuthReq: true,
                            },
                        ],
                    },
                ],
            },
            {
                path: 'archive',
                element: <ArchivePage />,
                layout: 'default',
                isAuthReq: true,
            },
        ],
    },
    {
        path: 'marketing',
        element: <MarketingPage />,
        layout: 'default',
        isAuthReq: true,
    },
];

export { StudentRealtionsRoutes };
